import { APICore } from "./apiCore";

const api = new APICore();

export interface ILike {
  id: number;
  historico_id: number;
  colaborador_id: number;
  createdAt: string;
  updatedAt: string;
}

export interface ICreateLikeRequest {
  historico_id: number;
  colaborador_id: number;
}

export interface IUpdateLikeRequest {
  historico_id: number;
  colaborador_id: number;
}

export const createLike = async (data: ICreateLikeRequest): Promise<ILike> => {
  const response = await api.create("/like", data);
  return response.data;
};

export const getLikes = async (params?: {
  historico_id?: number;
  colaborador_id?: number;
}): Promise<ILike[]> => {
  const queryParams = new URLSearchParams();
  
  if (params?.historico_id) {
    queryParams.append("historico_id", params.historico_id.toString());
  }
  
  if (params?.colaborador_id) {
    queryParams.append("colaborador_id", params.colaborador_id.toString());
  }

  const url = queryParams.toString() ? `/like?${queryParams.toString()}` : "/like";
  const response = await api.get(url);
  return response.data;
};

export const deleteLike = async (id: number): Promise<number> => {
  const response = await api.delete(`/like/${id}`);
  return response.data;
};

export const updateLike = async (id: number, data: IUpdateLikeRequest): Promise<ILike> => {
  const response = await api.update(`/like/${id}`, data);
  return response.data;
};
